// src/types/role.ts

// --- 1. Role Group Tipleri (Prisma modeline uygun) ---
/**
 * Rol Gruplarının temel yapısı.
 */
export interface RoleGroup {
  id: number;
  name: string;
}

/**
 * Yeni RoleGroup oluşturma veya güncelleme payload'ı.
 */
export interface RoleGroupPayload {
  name: string;
}

// --- 2. Geliştirilmiş Role Tipi (Eski yapınızın korunmuş ve güncellenmiş hali) ---
/**
 * Rolün ana yapısı.
 *
 * NOT: API'den gelen veriye uyum sağlamak adına bu tipteki 'roleGroup'
 * alanının RoleGroup nesnesi yerine string (ad) olması beklenmektedir.
 * Benzer şekilde, 'users' alanı da string olmalıdır.
 */
export interface RoleType {
  permissions: never[];
  id: number;
  name: string; // Rolün İngilizce adı (Örn: 'super_admin')
  level: number; // Yetki seviyesi
  firmId: number | null; 
  // İlişkiler
  roleGroupId: number | null; // Ait olduğu grubun ID'si (Prisma'daki gibi null olabilir)
  roleGroup: string; // Ait olduğu grubun adı (Eski yapınıza uyum için string)
   
  // Listeleme Ekstra Bilgileri
  users: string; // Bu role sahip kullanıcı sayısı (Eski yapınıza uyum için string)
  
  // Eğer API'den kullanıcı sayısı sayı olarak geliyorsa, bunu da kullanabilirsiniz:
  // userCount: number; 
}

/**
 * Yeni Role oluşturma veya güncelleme payload'ı.
 */
export interface RolePayload {
  name: string;
  level: number;
  roleGroupId: number | null; // Dialogdan gönderilecek
}

// --- 3. Yardımcı Fonksiyonlar ---

const roleNameMap: { [key: string]: string } = {
  super_admin: "Süper Yönetici",
  admin: "Yönetici",
  firm_admin: "Firma Yöneticisi",
  warehouse_staff: "Depo Görevlisi",
  firm_sales: "Firma Satış Temsilcisi",
  customer: "Müşteri",
    system_sync: "Senronizasyon Sistemi",
};

/**
 * İngilizce rol adını Türkçe karşılığına çevirir.
 */
export const getTurkishRoleName = (roleName: string): string => {
  return roleNameMap[roleName] || roleName; // Eşleşme yoksa orijinali döndür
};

// --- 4. Listeleme ve Store Tipleri ---

export interface RoleListQuery {
    page?: number;
    pageSize?: number;
    sortField?: keyof RoleType;
    sortOrder?: 'asc' | 'desc';
    search?: string;
    roleGroupId?: number | null;
}

/**
 * API'den dönen liste yanıtı yapısı (sayfalama bilgisi ile).
 */
export type RoleListResponse = {
    data: RoleType[];
    total: number;
    page: number;
    pageSize: number;
};

// --- 5. Permission Schema Types ---

export interface PermissionDependency {
  module: string;
  action: "canRead" | "canCreate" | "canUpdate" | "canDelete" | "canExport";
}

export interface PermissionActionDef {
  action: "canRead" | "canCreate" | "canUpdate" | "canDelete" | "canExport";
  label: string;
  implies?: PermissionDependency[]; 
}

export interface PermissionModuleDef {
  moduleKey: string;
  label: string;
  actions: PermissionActionDef[];
}

export interface PermissionGroupDef {
  groupKey: string;
  label: string;
  icon?: string;
  modules: PermissionModuleDef[];
}